














import { Prop, Component, Vue } from "vue-property-decorator";
import { Task } from "@/api/task-api";
import VTaskControl from "@/components/task/VTaskControl.vue";
import ITaskOutputOptions from "@/api/models/ITaskOutputOptions";

@Component({
  components: {
    VTaskControl
  }
})
export default class TaskEditModal extends Vue {
  @Prop({ required: true }) task!: Task;

  options: ITaskOutputOptions = {
    hasClosedDays: true,
    hasSubTasks: true
  };

  public show() {
    (this.$refs.modal as any).show();
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }

  init() {
    this.options = {
      hasClosedDays: Boolean(this.task.closedDays.length),
      hasSubTasks: Boolean(this.task.subTasks.length)
    };
  }

  update() {
    this.$emit("update", this.task, this.options);
    this.hide();
  }

  destroy() {
    this.$emit("delete", this.task);
    this.hide();
  }
}
